import { useLazyQuery } from "@apollo/client/react"; import React, { useState, useMemo, useEffect } from 'react';
import { Button } from '@mui/material';
import EmptyGridSvg from '../../../../assets/svg/EmptyGridInsumo.svg';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { BuscarInsumos } from './BuscarInsumos';
import { Grid } from '@mui/material';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../../components/popoverModal/PopoverModal';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';

import { adaptLumenesArray } from '../../../../adapters/lumenesAdapter';
import { adaptTipoInsumoArray } from '../../../../adapters/tipoInsumoAdapter';
import { adaptGrupoObligatorioArray } from '../../../../adapters/grupoObligatorioAdapter';
import { adaptAlergiaArray } from '../../../../adapters/alergiaAdapter';
import { adaptPresentacionNutricionArray } from '../../../../adapters/presentacionNutricionAdapter';
import { adaptFranjaEtariaArray } from '../../../../adapters/franjaEtariaAdapter';
import { adaptTipoAccesoArray } from '../../../../adapters/tipoAccesoAdapter';
import {
  GET_TIPO_INSUMOS,
  GET_LUMENES,
  GET_ALL_ALERGIAS,
  GET_ALL_PRESENTACION_NUTRICION,
  GET_ALL_TIPO_ACCESO
} from
  '../../../../data/graphQL/queries/Insumos/queries';
import { GET_ALL_FRANJA_ETARIA } from '../../../../data/graphQL/queries/PlanCuidado/getFranjaEtaria';
import { GET_GRUPO_OBLIGATORIO } from '../../../../data/graphQL/queries/Insumos/getGrupoObligatorio';
import toast, { Toaster } from 'react-hot-toast';
import './stepInsumos.scss';
export const StepInsumos = ({ stepsData, setStepsData }) => {
  const [franjaEtaria, setFranjasEtaria] = useState([]);
  const [tipoInsumos, setTipoInsumos] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  // get select data
  const [getFranjasEtarias, { loading: franjasEtariasLoading, data: franjaEtareaData }] = useLazyQuery(GET_ALL_FRANJA_ETARIA, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!franjaEtareaData) return;
    setFranjasEtaria(adaptFranjaEtariaArray(franjaEtareaData));
  }, [franjaEtareaData])

  const [getTipoInsumo, { loading: tipoInsumoLoading, data: tipoInsumoData }] = useLazyQuery(GET_TIPO_INSUMOS, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoInsumoData) return;
    setTipoInsumos(adaptTipoInsumoArray(tipoInsumoData).filter(x => x.id !== 1));
  }, [tipoInsumoData])

  useEffect(() => {
    if (!tipoInsumoLoading) {
      getTipoInsumo();
    }
    if (!franjasEtariasLoading) {
      getFranjasEtarias();
    }
  }, []);

  const handleEditRowClick = (editInsumo) => {
    setEditRow(editInsumo);
    setOpenModal(true);
  };

  const handleDeleteRowClick = (row) => {
    setStepsData((previousData) => ({
      ...previousData,
      insumos: [...(previousData.insumos || []).filter((c) => c.idInsumo !== row.idInsumo)]
    }));

    setEditRow(null);
  };

  const isValidInsumo = (insumo) => {
    if (stepsData?.insumos?.find(x => x.idPlanCuidadoInsumo != insumo.idPlanCuidadoInsumo && x.idInsumo == insumo.idInsumo && x.idTipoInsumo == insumo.idTipoInsumo && (x.idFranjaEtaria == insumo.idFranjaEtaria))) {
      toast.error('El insumo ya fue agregado para esa franja etaria.');
      return false;
    }
    if (stepsData?.insumos?.find(x => x.idPlanCuidadoInsumo != insumo.idPlanCuidadoInsumo && x.idInsumo == insumo.idInsumo && x.idTipoInsumo == insumo.idTipoInsumo && (x.idFranjaEtaria != insumo.idFranjaEtaria)
      && (x.idFranjaEtaria == 3))) {
      toast.error('El insumo ya fue agregado con franja etaria ambos.');
      return false;
    }
    if (stepsData?.insumos?.find(x => x.idPlanCuidadoInsumo != insumo.idPlanCuidadoInsumo && x.idInsumo == insumo.idInsumo && x.idTipoInsumo == insumo.idTipoInsumo && (x.idFranjaEtaria != insumo.idFranjaEtaria)
      && (insumo.idFranjaEtaria == 3))) {
      toast.error('El insumo ya fue agregado con franja etaria adulto o pedriatrico.');
      return false;
    }

    if (insumo.idInsumo <= 0) {
      toast.error('Debe seleccionar un Insumo.');
      return false;
    }
    if (insumo.idFranjaEtaria <= 0) {
      toast.error('Debe seleccionar una Franja Etaria.');
      return false;
    }

    return true;
  };

  const handleRowClick = (newInsumo) => {
    if (isValidInsumo(newInsumo)) {
      setStepsData((previousData) => ({ ...previousData, insumos: [...previousData.insumos, newInsumo] }));
      setOpenModal(false);
    }
  };

  const handleEditSaveRowClick = (editInsumo) => {
    if (isValidInsumo(editInsumo)) {
      setStepsData((previousData) => ({
        ...previousData,
        insumos: [...(previousData.insumos || []).filter((c) => c.idInsumo !== editInsumo.idInsumo), editInsumo]
      }));

      setOpenModal(false);
    }
  };

  const initialColumns = [
    {
      field: 'idTipoInsumo',
      headerName: 'Tipo',
      flex: 0.25,
      valueGetter: (idTipoInsumo) => tipoInsumos.find((insumo) => insumo.id == idTipoInsumo)?.displayName
    },
    {
      field: 'insumo',
      headerName: 'Insumo',
      flex: 0.6,
      valueGetter: (insumo) => insumo?.genericDescription
    },
    {
      field: 'cantidad',
      flex: 0.2,
      headerName: 'Cantidad'
    },
    {
      field: 'baseCalculo',
      headerName: 'Base Cálculo',
      flex: 0.3
    },
    {
      field: 'idFranjaEtaria',
      headerName: 'Franja Etarea',
      flex: 0.3,
      valueGetter: (idFranjaEtaria) => franjaEtaria.find((fEtaria) => fEtaria?.id == idFranjaEtaria)?.displayName || ''
    },
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div
                  onClick={() => handleEditRowClick(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <EditIcon className='edit-icon' />
                  <span className='toggle-action'>Editar</span>
                </div>
                <div
                  onClick={() => handleDeleteRowClick(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <DeleteOutlineIcon className='edit-icon' />
                  <span className='toggle-action'>Eliminar</span>
                </div>
              </div>
            </PopoverModal>
          </>);

      }
    }];

  const columns = generateColumnsDefaultConfiguration(initialColumns);
  return (
    <div>

      {
        stepsData?.insumos?.length == 0 &&
        <div className='step-insumos'>
          <div className='empty-grid'>
            <img className='empty-grid-svg' src={EmptyGridSvg} width="100%"></img>
            <p>No se ha agregado ningún insumo</p>
            <CustomButton
              variant={'contained'}
              onClick={() => setOpenModal(true)}
              size={'small'}>

              Agregar insumo
            </CustomButton>
          </div>
        </div>
      }

      {
        stepsData?.insumos?.length > 0 &&
        <>
          <div className='button-agregar-insumo'>
            <CustomButton
              variant='contained'
              onClick={() => { setEditRow(null); setOpenModal(true); }}
              disableElevation
              size='small'>

              Agregar Insumo
            </CustomButton>
          </div>
          <div className='insumoss-grilla'>
            <DataGridGenerico
              hideFooterPagination={false}
              toolbar={false}
              columns={columns}
              rows={stepsData?.insumos} />

          </div>
        </>
      }
      <BuscarInsumos
        open={openModal}
        onRowClick={handleRowClick}
        onEditRowClick={handleEditSaveRowClick}
        onClose={() => setOpenModal(false)}
        rowData={editRow}
        stepsData={stepsData}
        tipoInsumos={tipoInsumos}
        franjaEtaria={franjaEtaria}
        key={stepsData.insumos}
      />

    </div>);

};
